import Vue from 'vue'
import Router from 'vue-router'
import FilmEn from './templates/FilmEn'
import Film from './templates/Film'
import Schedule from './templates/Schedule'
import ScheduleEn from './templates/ScheduleEn'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/en/lineup/film/',
      component: FilmEn,
    },
    {
      path: '/en/lineup/film/:id',
      name: 'filmenrouter',
      component: FilmEn,
    },
    {
      path: '/ja/lineup/film/',
      component: Film,
    },
    {
      path: '/ja/lineup/film/:id',
      name: 'filmrouter',
      component: Film,
    },
    {
      path: '/ja/schedule/list/',
      component: Schedule,
    },
    {
      path: '/ja/schedule/list/:id',
      component: Schedule,
    },
    {
      path: '/en/schedule/list/',
      component: ScheduleEn,
    },
    {
      path: '/en/schedule/list/:id',
      component: ScheduleEn,
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history'
})
export default router



// WEBPACK FOOTER //
// ./src/router.js